(function () {
    'use strict';

    angular
        .module('app.addPostToProject',[])
        .factory('addPostToProjectService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope)
            {
                var service = {};

                function handleRequest(url, method, params, loader)
                {
                    var deferred = $q.defer();
                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    }

                    $http(req).success(function (response) {
                        deferred.resolve(response);
                    })
                    .error(function () {
                        deferred.reject(null);
                    });

                    return deferred.promise;
                }

                function getAllProjectByAdvertiserID(advertiserID, loader)
                {
                    var url_getAllProject = $rootScope.apiUrl + 'common/getAllProjectByAdvertiserID/' + advertiserID;
                    return handleRequest(url_getAllProject, 'GET', null, loader);
                }

                function getListProjectAddPost(companyId, postUrlHash, loader)
                {
                    var url_getListProjectAddPost = $rootScope.apiUrl + 'project/getListProjectAddPost?companyId=' + companyId +'&postUrlHash=' + postUrlHash;
                    return handleRequest(url_getListProjectAddPost, 'GET', null, loader);
                }

                function addPostToProject(params, loader)
                {
                    var url_addPostToProject = $rootScope.apiUrl + 'project/addPostToProject';
                    return handleRequest(url_addPostToProject, 'POST', params, loader);
                }

                function removeAddPostToProject(params, loader)
                {
                    var url_removeAddPostToProject = $rootScope.apiUrl + 'project/removeAddPostToProject';
                    return handleRequest(url_removeAddPostToProject, 'PUT', params, loader);
                }

                service.getAllProjectByAdvertiserID = getAllProjectByAdvertiserID;
                service.getListProjectAddPost = getListProjectAddPost;
                service.addPostToProject = addPostToProject;
                service.removeAddPostToProject = removeAddPostToProject;
                return service;
            }
        ])
})();
